import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { TokenService } from '../core/token/token.service';

@Injectable({
  providedIn: 'root'
})
export class IaChamadoHttpService {
  private apiUrl = environment.apiGestorUrlLocal;
  private configIaAlterada$ = new Subject<void>();

  configIaAlterada(): Observable<void> {
    return this.configIaAlterada$.asObservable();
  }

  notificarConfigIaAlterada(): void {
    this.configIaAlterada$.next();
  }
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'authorization': this.tokenService.getToken(),
      'session': this.tokenService.getSessionUsuario()
    }),
    params: {}
  };

  constructor(
    private tokenService: TokenService,
    private http: HttpClient
  ) { }

  getFuncionalidadesHabilitadas(): Observable<{ data: { ia_milvus: boolean } }> {
    this.httpOptions.params = {};
    return this.http.get<{ data: { ia_milvus: boolean } }>(
      `${this.apiUrl}api/chatGpt/funcionalidades-habilitadas`,
      this.httpOptions
    ).pipe(catchError(this.handleError));
  }

  consultar(mensagem: string, sessaoId?: string): Observable<{ sucesso: boolean; resposta: string; log_id: string; sessao_id: string }> {
    this.httpOptions.params = {};
    const body = sessaoId ? { mensagem, sessao_id: sessaoId } : { mensagem };
    return this.http.post<{ sucesso: boolean; resposta: string; log_id: string; sessao_id: string }>(
      `${this.apiUrl}api/ia-chamado/consultar`,
      body,
      this.httpOptions
    ).pipe(catchError(this.handleError));
  }

  avaliar(logId: string, avaliacao: 'like' | 'dislike'): Observable<void> {
    this.httpOptions.params = {};
    return this.http.put<void>(
      `${this.apiUrl}api/ia-chamado/${logId}/avaliar`,
      { avaliacao },
      this.httpOptions
    ).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('Ops! Ocorreu um erro:', error.error);
    } else {
      console.error(`Backend retornou o código ${error.status}`, error);
    }
    return throwError(error.error);
  }
}
